<!--Tạo lô hợp đồng-->
<mat-card *ngIf="isShowStep">
  <form>
    <mat-card-header>
      <mat-card-title class="mat-card-title-custom">
        <span *ngIf="viewMode === 'view'">{{ "title.view_lot_standardized_moha" | translate }}</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mb-3 mat-card-content-contract-sm" style="margin-top: 16px;">
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel expanded="true" class="mb-3" *ngIf="viewMode === 'view'" disabled>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              <div class="row" style="width: 100%">
                <div class="col-3 title-panel">
                  {{ "title.list_contract_create" | translate }}
                </div>
                <div class="col-9 d-flex justify-content-between" *ngIf="processing">
                  <div class=" title-panel">{{ "contract_lot.contract_lot_processing" | translate }} ({{
                    processing.percent ? processing.percent : 0 }}%)</div>
                  <div class="d-flex flex-column justify-content-center" style="width: calc(100% - 200px);">
                    <mat-progress-bar mode="determinate" [value]="processing.percent" [bufferValue]="100">
                    </mat-progress-bar>
                  </div>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="contract-lot-detail">
            <div class="row">
              <div class="col-12 d-flex justify-content-between">
                <div>
                  <b>{{ "contract_lot.contract_lot_code" | translate }}:</b>
                  {{
                  contractLot && contractLot.code ? contractLot.code : null
                  }}
                </div>
                <div class="d-flex">
                  <div class="mr-4">
                    <b>{{ "contract_lot.total_contract" | translate }}:</b>
                    {{ renderNumber("total") }}
                  </div>
                  <div class="mr-4">
                    <b>{{ "contract_lot.contract_success" | translate }}:</b>
                    {{ renderNumber("success") }}
                  </div>
                  <div>
                    <b>{{ "contract_lot.contract_error" | translate }}:</b>
                    {{ renderNumber("error") }}
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-between pt-4">
                <p class="font-weight-bold">
                  {{ "contract_lot.result" | translate }}
                </p>
                <a class="file-result" *ngIf="!processing" (click)="getResultFile()">{{
                  "contract_lot.download_result_file" | translate
                  }}</a>
              </div>
              <div class="col-12">
                <nz-table #rowsTable nzBordered [nzData]="contractLot.contractDetails" [nzShowPagination]="false"
                  [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                  <thead>
                    <tr>
                      <th class="text-center" nzWidth="55px">
                        {{ "contract_lot.table_detail.index" | translate }}
                      </th>
                      <!-- <th class="text-center" nzWidth="20%">
                        {{
                          "contract_lot.table_detail.customer_type" | translate
                        }}
                      </th> -->
                      <th class="text-center" nzWidth="8%">
                        {{ "contract_lot.table_detail.row" | translate }}
                      </th>
                      <th class="text-center" nzWidth="20%">
                        {{
                        "contract_lot.table_detail.contract_code" | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="20%">
                        {{
                        "contract_lot.table_detail.customer_name" | translate
                        }}
                      </th>
                      <th class="text-center" nzWidth="15%">
                        {{ "contract_lot.table_detail.status" | translate }}
                      </th>
                      <th class="text-center" nzWidth="35%">
                        {{
                        "contract_lot.table_detail.error_detail" | translate
                        }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of rowsTable.data; let i = index">
                      <td class="text-center">{{ i + 1 }}</td>
                      <!-- <td class="text-center">
                        <span *ngIf="data.customerType === 'PERSONAL'">{{
                          "contract_lot.customer_type.personal" | translate
                        }}</span>
                        <span *ngIf="data.customerType === 'ENTERPRISE'">{{
                          "contract_lot.customer_type.enterprise" | translate
                        }}</span>
                      </td> -->
                      <td class="text-center">
                        {{ data.orderNo ? data.orderNo : '' }}
                      </td>
                      <td  nz-tooltip [nzTooltipTitle]="(data.contractCode ? data.contractCode : '') + ' - ' + (data.contractName ? data.contractName : '')">
                        {{ data.contractCode ? (data.contractCode | slice:0:20) : '' }}
                        <span *ngIf="data.contractCode && data.contractCode.length > 20">...</span>
                         - {{ data.contractName ? (data.contractName | slice:0:20) : '' }}
                         <span *ngIf="data.contractName && data.contractName.length > 20">...</span>
                      </td>
                      <td  nz-tooltip  [nzTooltipTitle]="data.customerName">
                        {{ data.customerName ? (data.customerName | slice:0:30) : '' }}<span
                          *ngIf="data.customerName && data.customerName.length > 30">...</span>
                      </td>
                      <td class="text-center" [ngStyle]="renderStatusColor(data.status)">
                        {{ renderStatus(data.status) }}
                      </td>
                      <td nz-tooltip  [nzTooltipTitle]="data.errorMessage">
                        {{ data.errorMessage ? (data.errorMessage| slice:0:40) :  '' }}<span
                          *ngIf="data.errorMessage && data.errorMessage.length > 40">...</span>
                      </td>
                    </tr>
                  </tbody>
                </nz-table>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
  </form>
</mat-card>
